import axiosInstance from '$api/index';
import {ApiRoute} from '$constants/api';

export interface BillingItem {
  id: number;
  description: string;
  notes: string | null;
  amount: number;
  category: string;
  item_name: string;
  ccsd_code: string | null;
}

export interface InsuranceClaim {
  id: number;
  status: string;
  amount: number;
  insurance_id: number;
  membership_no: string;
  pre_authorisation_code: string;
  insurer_name: string;
  patient_name: string;
  patient_id: number;
  last_updated: string;
  invoice_number: number;
  invoice_issued_at: string | null;
  items?: BillingItem[];
  approved_amount?: number;
  outstanding_amount?: number;
  email?: string;
  phone?: string;
  country_code?: string;
  payment_id?: number;
}

export interface InsuranceClaimDetailsResponse {
  success: boolean;
  data: {
    insurance_claim: InsuranceClaim;
  };
  message: string;
}

export async function getInsuranceClaimDetails(
  id: string
): Promise<InsuranceClaimDetailsResponse> {
  const response = await axiosInstance.get<InsuranceClaimDetailsResponse>(
    `${ApiRoute.InsuranceClaims}/${id}`
  );
  return response.data;
}

export interface UpdateInsuranceClaimPayload {
  insurance_claim: {
    insurance_id: number;
    membership_no: string;
    pre_authorisation_code: string;
    status?: string;
    approved_amount?: number;
    outstanding_amount?: number;
    send_email?: boolean;
    send_sms?: boolean;
  };
}

export interface UpdateInsuranceClaimResponse {
  success: boolean;
  data: {
    insurance_claim: InsuranceClaim;
  };
  message: string;
}

export async function updateInsuranceClaim(
  id: string,
  payload: UpdateInsuranceClaimPayload
): Promise<UpdateInsuranceClaimResponse> {
  const response = await axiosInstance.put<UpdateInsuranceClaimResponse>(
    `${ApiRoute.InsuranceClaims}/${id}`,
    payload
  );
  return response.data;
}

export interface DeleteBillingItemResponse {
  success: boolean;
  data: {
    insurance_claim: InsuranceClaim;
  };
  message: string;
}

export async function deleteBillingItem(
  itemId: string
): Promise<DeleteBillingItemResponse> {
  const response = await axiosInstance.delete<DeleteBillingItemResponse>(
    `${ApiRoute.InsuranceClaims}/delete_item/${itemId}`
  );
  return response.data;
}

export interface DeleteInsuranceClaimResponse {
  success: boolean;
  message: string;
}

export async function deleteInsuranceClaim(
  id: string
): Promise<DeleteInsuranceClaimResponse> {
  const response = await axiosInstance.delete<DeleteInsuranceClaimResponse>(
    `${ApiRoute.InsuranceClaims}/${id}`
  );
  return response.data;
}
